const productBadge = `
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    font-weight: 400;
    font-family: GT-America-Standard-Medium, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: .36px;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    border-radius: 6px;
    padding: 4px 10px;
    background: #8ae5d3;
    color: #3a3e43;`;

const BadgeStyle = {
  product: productBadge,
  bestSeller: `
    ${productBadge}
    position: relative;
    top: auto;
    left: -18%;
    height: 18px;
    background-color: #D2EAE5;
    font-weight: 500;
    color: #3A3E43;
   `
};

export default BadgeStyle;
